import { doc, getDoc } from "firebase/firestore";
import { Firestore } from "../../firebase/firebase";

export type CampaignTypeFooter = {
  main?: string;
  info?: string;
  org_nr?: string;
  agreement_url?: string;
};

export async function getFooterInformation(
  campaignTypeId: string | undefined | null,
  tags: string[] | undefined | null,
): Promise<CampaignTypeFooter | null> {
  if (!campaignTypeId) return null;

  const getFooterFromDoc = async (docId: string) => {
    const ref = doc(
      Firestore,
      "common",
      "configuration",
      "campaign_types",
      campaignTypeId,
      "information",
      docId,
    );

    const snap = await getDoc(ref);
    if (!snap.exists()) return null;

    const data: any = snap.data();
    return data?.footer ?? null;
  };

  const candidates = (tags ?? [])
    .map((t) => (typeof t === "string" ? t.trim() : ""))
    .filter((t) => t && t.toLowerCase() !== "default");

  for (let i = 0; i < candidates.length; i++) {
    const footer = await getFooterFromDoc(candidates[i]);
    if (footer) return footer;
  }

  return await getFooterFromDoc("default");
}
